import { Typography } from 'antd';
import CustomTable from './CustomTable';
import CustomFilter from '../common/CustomFilter';
import { useEffect, useState } from 'react';
import { formatIndianStyle } from '../helper/arrayFormatter';

const { Title } = Typography;
const FILL_COLOR = "rgb(59, 130, 246)";

function ProgressView({
	title = "",
	data,
	preferredOrder,
	ignoreFirstIndexing,
	index,
	totalLength,
	sorter = false,
	isDownloadPdf = false,
	isLoading = false,
	onRow,
	rowHoverable = false,
}) {
	const [HighestValue, setHighestValue] = useState()

	useEffect(() => {
		if (!data || data.length === 0) return;

		const tempHighestValue = {}

		for (let index = ignoreFirstIndexing ? 0 : 1; index < data?.[0]?.length; index++) {
			let sortedData = [...data];
			sortedData = sortedData.sort((a, b) => b?.[index] - a?.[index]);
			tempHighestValue[index] = sortedData?.[1]?.[index];
		}

		setHighestValue(tempHighestValue)
	}, [data]);


	const dynamicColumn = () => {
		const columns = preferredOrder?.map((key, index) => {
			const sorterFunction = (aValue, bValue) => {
				if ([aValue[0], bValue[0]].includes("TOTAL")) {
					return 0
				}
				const findex = preferredOrder?.findIndex(item => item === key)
				if (typeof aValue[findex] === "string" && typeof bValue[findex] === "string") {
					return aValue[findex].localeCompare(bValue[findex]);
				}

				if (!isNaN(aValue[findex]) && !isNaN(bValue[findex])) {
					return aValue[findex] - bValue[findex];
				}
				else {
					return 0;
				}
			}

			sorter = sorter ? { sorter: sorterFunction } : undefined

			return {
				title: <CustomFilter key={index}
					title={key?.replace(/_/g, ' ')?.toUpperCase()}
				/>,
				align: "center",
				dataIndex: index,
				key: index,
				render: (text, record) => {
					let highest = HighestValue?.[index]
					let curPerc = 0;

					if (key?.endsWith("%")) {
						curPerc = text === "100" ? "0" : text;
					}
					else if (highest > 0) {
						curPerc = text / highest * 100
						if (curPerc > 100) {
							curPerc = 0
						}
					}

					if (record[0] === "TOTAL" || key === "Total Pax") {
						curPerc = 0
					}

					return <div style={{ flex: 1, position: "relative" }}>
						{key !== "Airport" && <div style={{
							zIndex: 1, flex: 1, width: `${curPerc}%`, height: "100%", borderRadius: "5px",
							position: "absolute", backgroundColor: "rgb(59 163 246 / 90%)",
							transition: 'width 0.5s ease', top: isDownloadPdf ? 6 : 0
						}}>
						</div>}
						<div style={{ flex: 1, position: "relative", zIndex: 2, marginRight: "5px", marginTop: "-1px", marginBottom: "-1px" }}>
							<p className="text-right">{formatIndianStyle(text) + (key?.endsWith("%") ? "%" : "")}</p>
						</div>
					</div>
				},
				...sorter
			}
		})

		return columns
	}


	return (
		<div>
			<Title level={5} style={{
				background: FILL_COLOR, borderRadius: "5px 20px", marginLeft: "15px",
				paddingInline: "35px", color: "#FFF", width: "fit-content", transition: "height 0.5s ease",
				marginTop: 20, marginBottom: 20, height: isDownloadPdf ? 32 : 25, boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)'
			}}>
				{title}
			</Title>

			<div style={index > 0 && index < totalLength - 1 ?
				{ overflow: "hidden", marginInline: '6px', "-webkit-box-shadow": '0 4px 10px rgba(0, 0, 0, 0.2)', borderRadius: 15 }
				:
				{ overflow: "hidden", marginInline: '6px', "-webkit-box-shadow": '0 4px 10px rgba(0, 0, 0, 0.2)', borderRadius: 15 }}>
				<CustomTable
					data={data}
					columns={dynamicColumn()}
					bordered={false}
					loading={isLoading}
					scroll={{ x: true }}
					pagination={false}
					onRow={onRow}
					rowHoverable={rowHoverable}
				/>
			</div>
		</div>
	)
}

export default ProgressView
